var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49879 12.8387C7.31724 12.8387 8.02204 12.4041 8.33129 11.784H4.66629C4.97554 12.4041 5.68037 12.8387 6.49879 12.8387Z",
    fill: "#155EEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6321 6.64792V5.87772C10.6321 4.24126 9.39449 2.85426 7.69879 2.40123V1.89334C7.69879 1.31179 7.16047 0.838654 6.49879 0.838654C5.83711 0.838654 5.2988 1.31179 5.2988 1.89334V2.40123C3.60307 2.85426 2.36547 4.24124 2.36547 5.87772V6.64792C2.36547 8.08539 1.74206 9.44842 0.61009 10.486C0.499157 10.5876 0.467984 10.7376 0.530864 10.8672C0.593743 10.9968 0.738543 11.0808 0.898809 11.0808H12.0988C12.259 11.0808 12.4038 10.9968 12.4667 10.8672C12.5296 10.7376 12.4984 10.5876 12.3875 10.486C11.2555 9.44842 10.6321 8.08536 10.6321 6.64792ZM6.89879 2.26197C6.76714 2.25081 6.63373 2.2449 6.49879 2.2449C6.36386 2.2449 6.23045 2.25081 6.09879 2.26197V1.89334C6.09879 1.69949 6.27823 1.54178 6.49879 1.54178C6.71935 1.54178 6.89879 1.69949 6.89879 1.89334V2.26197Z",
    fill: "#155EEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6988 5.87771C11.6988 6.07186 11.8779 6.22927 12.0988 6.22927C12.3197 6.22927 12.4988 6.07186 12.4988 5.87771C12.4988 4.46911 11.8747 3.14482 10.7414 2.1488C10.5852 2.01153 10.332 2.0115 10.1758 2.1488C10.0195 2.2861 10.0195 2.50868 10.1758 2.64598C11.1579 3.50921 11.6988 4.65692 11.6988 5.87771Z",
    fill: "#155EEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.898809 6.22929C1.11971 6.22929 1.29881 6.07188 1.29881 5.87772C1.29881 4.65696 1.83971 3.50925 2.82184 2.64602C2.97806 2.50872 2.97806 2.28614 2.82184 2.14884C2.66566 2.01154 2.41238 2.01154 2.25616 2.14884C1.12291 3.14486 0.49881 4.46913 0.49881 5.87772C0.49881 6.07188 0.677903 6.22929 0.898809 6.22929Z",
    fill: "#155EEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBlue);
export default __webpack_public_path__ + "static/media/bell-blue.8254e7d8e5cdc1aec8b189f82fbf17a1.svg";
export { ForwardRef as ReactComponent };